import { render, staticRenderFns } from "./contractCustomer.vue?vue&type=template&id=4a6573b4&"
import script from "./contractCustomer.vue?vue&type=script&lang=js&"
export * from "./contractCustomer.vue?vue&type=script&lang=js&"
import style0 from "./contractCustomer.vue?vue&type=style&index=0&id=4a6573b4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports